import Checkbox from "@mui/material/Checkbox";
import { MRT_ColumnDef } from "material-react-table";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AiconGameGroup } from "@/module/service-configs-module/aicon-game-group-module/aicon-game-group-table";
import { AnyObj } from "@/types/commonTypes";


export const useAiconGameGroupTableColumns = () => {
  const { t } = useTranslation();

  return useMemo<MRT_ColumnDef<AiconGameGroup>[]>(
    () => [
      {
        header: t("enabled"),
        filterFn: "contains",
        accessorKey: "enabled",
        enableEditing: false,
        accessorFn: (row) => row.enabled ?? "-",
        Cell: ({ row }) => <Checkbox checked={row.original.enabled} disabled />,
        grow: true,
      },
      {
        header: t("name"),
        accessorKey: "name",
        sortingFn: "alphanumeric",
        filterFn: "contains",
      },
      /*{
        header: t("ai_ids"),
        accessorKey: "data.ai_ids",
        accessorFn: (config) => config.data?.ai_ids?.join(", ") ?? "-",
        sortingFn: "alphanumeric",
        filterFn: "contains",
      },
      {
        header: t("room_ids"),
        accessorKey: "data.room_ids",
        accessorFn: (config) => config.data?.room_ids?.join(", ") ?? "-",
        sortingFn: "alphanumeric",
        filterFn: "contains",
      },
      {
        header: t("limits"),
        accessorKey: "data.limits",
        accessorFn: (config) => config.data?.limits?.join(", ") ?? "-",
        sortingFn: "alphanumeric",
        filterFn: "contains",
      },*/
      {
        header: t("tg_link"),
        accessorKey: "data.tg_link",
        sortingFn: "alphanumeric",
        filterFn: "contains",
      },
      {
        header: t("expired_at"),
        accessorKey: "data.expired_at",
        sortingFn: "alphanumeric",
        filterFn: "contains",
      },
      {
        header: t("ai_subject"),
        accessorKey: "data.ai_subject",
        sortingFn: "alphanumeric",
        filterFn: "contains",
      },
      {
        header: t("token"),
        accessorKey: "data.token",
        sortingFn: "alphanumeric",
        filterFn: "contains",
      },
    ],
    [t]
  );
};
